import {Injectable} from '@angular/core';
import {RequestService} from '../../../service/request.service';
import {WsCustomerBankAccount, WsDaoEventEntityType, WsRef} from '@lifeislife/lifeislife-ws-api';
import {CachedWsResourceClient} from '../../../private_util/client/cached-http-ws-Resource-client';
import {AuthProvider} from '../../../domain/auth/auth-provider';
import {ResourceCacheService} from '../../../../util/cache/resource-cache.service';
import {AppConfigService} from '../../../../service/config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerBankAccountWsClient extends CachedWsResourceClient<WsCustomerBankAccount, WsRef<WsCustomerBankAccount>> {

  constructor(private injectedRequestService: RequestService,
              private injectectedCacheService: ResourceCacheService,
              private injectedAuthService: AuthProvider,
              private injectedAppConfigService: AppConfigService) {
    super('/front/customerBankAccount', injectedAppConfigService, injectedRequestService, injectedAuthService,
      WsDaoEventEntityType.CUSTOMER_BANK_ACCOUNT, injectectedCacheService);
  }

}
